import "./DecodeRow.css";
import { useContext, useState, useEffect } from "react";
import { Buffer } from "buffer";

import Peg from "./Peg";
import { ThemeContext } from "../App";
import { CheckIcon } from "./Icons";
// import Hint from "./Hint";

const DecodeRow = (props) => {
  const {
    ATTEMPTS, 
    PEGSINROW, 
    CODES, 
    SUCCESSCODE, 
    selectedPeg, 
    rowId, 
    activatedRow, 
    setActivatedRow, rowsAnswers, 
    currentGuess, setRowsAnswers, decodeRowsHints, 
    currentRowHints, setDecodeRowsHints, decodeRow,
    decodeRows, setDecodeRows,setOutOfChances,
    setWinnerModal } = props
  //theme
  const theme = useContext(ThemeContext);
  // current decode row guesses
  const [currentRow, setCurrentRow] = useState({});
  // for tracking if current decode row is submitted or not
  const [pegsSubmitted, setPegsSubmitted] = useState(false);
  // decode pegs count
  const decodeRowPegs = new Array(PEGSINROW);
  // decode pegs hints count
  // const decodeRowHints = new Array(PEGSINROW).fill();


  // setting current peg guesses
  // storing as a object
  const handleDecodeRowClick = (e) => {
    setRowsAnswers({...rowsAnswers, [rowId]:{
      ...currentGuess,
      [e.target.name]: currentGuess[e.target.name] === selectedPeg ? "" : selectedPeg,
    }});
  };

  // filling peg color in decoding row
  // const pegLabelHandler = (e) => {
  //   // e.target.style.backgroundColor = `${props.CODES[props.selectedPeg]}`;
  // };

  // peg submit handler
  const handleDecodeRowSubmit = () => {
    let exactMatches = 0;
    const guess = Object.values(currentGuess).map(key => CODES[key]);
    let successCodeValues = Array.from(SUCCESSCODE.values());
    let _updatedHints = [];

    // for exact matches
    for(let [key, value] of SUCCESSCODE){
      if(guess[key] === value){
        exactMatches++;
        _updatedHints.push("#68B984");
      }
    };

    // for matches 
    for(let val of guess){
      const index = successCodeValues.indexOf(val);
      if(index> -1){
          successCodeValues.splice(index, 1)
      }
    }

    let noMatches = successCodeValues.length;
    let matches = PEGSINROW - exactMatches - successCodeValues.length;

    //push machtes hint color
    while(matches > 0){
      _updatedHints.push('#EAF6F6');
      matches--;
    };

    // push no matches at all color
    while(noMatches > 0){
      _updatedHints.push('#DC3535');
      noMatches--;
    };

    const _decodeRowsHints = [...decodeRowsHints];
    _decodeRowsHints[rowId] = [..._updatedHints ]
    setDecodeRowsHints([..._decodeRowsHints]);
    localStorage.setItem('hints', JSON.stringify(_decodeRowsHints));

    // if all matches are correct => WINS!! window reloads
    if (exactMatches === PEGSINROW) {
      setWinnerModal(true);
      localStorage.removeItem('hints');
      localStorage.removeItem('activatedRow');
      localStorage.removeItem('decoded');
      localStorage.removeItem('decodes');
      localStorage.removeItem('successcode');

    } else {
      // else to continue the game next decode row highlights
      let prevActivatedRow = activatedRow;
      prevActivatedRow++;
      setActivatedRow(prevActivatedRow);
      localStorage.setItem('activatedRow', prevActivatedRow);
    }
    // if all chances are Over
    if (rowId === ATTEMPTS - 1) {
      setOutOfChances(true);
      localStorage.removeItem('hints');
      localStorage.removeItem('activatedRow');
      localStorage.removeItem('decoded');
      localStorage.removeItem('decodes');
      localStorage.removeItem('codex');
    }
    const _decodeRows = [...decodeRows];
    _decodeRows[rowId] = true;
    setDecodeRows([..._decodeRows]);
    localStorage.setItem('decoded', JSON.stringify(_decodeRows));

    localStorage.setItem('decodes', JSON.stringify(rowsAnswers));
    const _successCode = Array.from(SUCCESSCODE);
    const _bufferedSuccessCode=_successCode.map(code => [code[0], Buffer.from(code[1]).toString('base64')]);
    localStorage.setItem('codex', JSON.stringify(_bufferedSuccessCode));
    setPegsSubmitted(true);
  };

  return (
    <div
      className={`row ${
        rowId === activatedRow
          ? `decode-row ${theme.backgroundColor} drop-shadow-xl flex justify-center rounded-full`
          : "drop-shadow-md decode-row-disabled"
      }`}
    >
      <div className="row decode-row-pegs">
        {decodeRowPegs.fill().map((_, i) => {
          return (
            <div className="mx-0.5">
              <Peg
                key={`decodeRow-${rowId}-${i}`}
                id={`decodeRow-${rowId}-${i}`}
                name={i}
                value={currentGuess[i]}
                onClick={(e) => handleDecodeRowClick(e)}
                // pegLabelHandler={pegLabelHandler}
                color = {CODES[currentGuess[i]] ? CODES[currentGuess[i]] : ""}
              />
            </div>
          );
        })}
      </div>
      <div className="submit-pegs">
        {activatedRow ===rowId &&
        !(Object.values(currentGuess).length && Object.values(currentGuess).some(guess => guess === "" || guess == undefined))
        ? 
        (
          <div onClick={handleDecodeRowSubmit}>
            <CheckIcon strokeColor={"#68B984"} strokeWidth = {2.5} size ={"40px"} />
          </div>
        ) 
        : 
        decodeRow 
        ? 
        <div className="row hints">
          {currentRowHints.map((_, i) => {
            return <Hint key={i} backgroundColor={_} />;
          })} 
        </div>
        : null}
      </div>
    </div>
  );
};

export default DecodeRow;

const Hint = (props) => {
  return (
    <div
      className="hint drop-shadow-md"
      style={{ backgroundColor: props.backgroundColor }}
    ></div>
  );
};